import React, {useEffect, useState} from "react";
// reactstrap components
import {
    Button,
    Card,
    CardBody,
    Col,
    Form,
    FormGroup,
    Input,
    InputGroup,
    InputGroupAddon,
    InputGroupText,
    Row
} from "reactstrap";
import LocalizedStrings from "react-localization";
import {common_strings} from "../../translations/common_translations";
import localeHelpers from "../../helpers/LocaleHelper";
import businessHelper from "../../helpers/BusinessHelper";
import lsHelpers from "../../helpers/LsHelper";
import businessApiService from "../../api/business-api-service";
import {Redirect} from "react-router-dom";
import Select from "react-select";
import dateHelpers from "../../helpers/DateHelper";
import ErrorModal from "../../components/Alerts/ErrorModal";
import LanguagePanel from "../../components/utils/LanguagePanel";

import {useObservable} from "../../components/utils/observable/observableHook";
import {localeService} from "../../components/utils/observable/services";
import {RotateCircleLoading} from "react-loadingg";
import LoadingOverlay from "react-loading-overlay";
import constants from "../../shared/constants";

let commonStrings = new LocalizedStrings(common_strings);

const PasswordReset = (props) => {

    const locale = useObservable(localeService.locale);

    const [error, setError] = useState(null);
    const [stage, setStage] = useState(constants.passwordResetStage.forgot);
    const [showError, setShowError] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const [toDashboard, setToDashboard] = useState(false);
    const [toRegister, setToRegister] = useState(false);
    const [toLogin, setToLogin] = useState(false);
    const [validation, setValidation] = useState({
        email: false,
        password: false,
        code: false,
    });
    const [formData, setFormData] = useState({email: '', password: '', code: ''});

    function handleNetworkError(e) {
        setError(e);
        setShowError(true);
        setLoading(false);
    }

    useEffect(() => {
        // setShowError(false);
        // setError(null);
    });

    function handleValidation() {
        setValidation({
            email: emailIsValid(),
            password: formData.password.length > 2,
            code: formData.code.length > 2,
        });
    };

    function emailIsValid() {
        const e = formData.email.trim();
        return e.length > 5 && e.includes("@") && e.includes(".") && e.length - e.indexOf(".") > 2
    };

    function saveUserSession(data) {
        businessHelper.saveUserSession(data);
        lsHelpers.createDatesRecord();
    };

    function handleChange(event) {
        let newValue = event.target.value;

        const f = formData;

        if (event.target.id === 'input-email') {
            f.email = newValue;
        } else if (event.target.id === 'input-password') {
            f.password = newValue;
        } else if (event.target.id === 'input-reset-code') {
            f.code = newValue;
        }

        setFormData(f);
        handleValidation();
    }

    function sendResetCode() {
        setLoading(true);

        businessApiService.forgot(formData.email.trim())
            .then(res => {
                if (res.error) {
                    setShowError(true);
                    setError({message: res.error});
                } else {
                    if (res.status) {
                        setStage(constants.passwordResetStage.reset);
                        setLoading(false);
                    } else setLoading(false);
                }
            })
            .catch((e) => {
                handleNetworkError(e)
            });
    }

    function resetPassword() {
        setLoading(true);

        const data = {
            token: formData.code,
            email: formData.email.trim(),
            password: formData.password,
            locale: locale,
        };

        businessApiService.reset(data)
            .then(res => {
                login()
            })
            .catch((e) => {
                handleNetworkError(e)
            });
    }

    function handleSubmit(event) {
        event.preventDefault();

        if (stage === constants.passwordResetStage.forgot) {
            sendResetCode();
        } else {
            resetPassword();
        }
    }

    function validationCleared() {
        return Object.values(validation).every(item => item)
    }

    function login() {
        businessApiService.login(formData.email.trim(), formData.password)
            .then(res => {
                saveUserSession(res);
                setToDashboard(true);
            })
            .catch((e) => {
                handleNetworkError(e)
            });
    }

    function toggleErrorModal() {
        setError(null);
        setShowError(false);
    }

    function onLanguageChanged(locale) {
        localeService.setLocale(locale);
    }

    localize();

    if (toDashboard === true) {
        return <Redirect from="*" to="/admin/index"/>
    }

    function goToRegister(e) {
        e.preventDefault();
        setToRegister(true)
    }

    function goToLogin(e) {
        e.preventDefault();
        setToLogin(true)
    }

    if (toLogin === true) {
        return <Redirect from="*" to="/auth/login"/>
    }

    if (toRegister === true) {
        return <Redirect from="*" to="/auth/register"/>
    }

    function stageValidation() {
        switch (stage) {
            case constants.passwordResetStage.forgot:
                return !emailIsValid();
            case constants.passwordResetStage.reset:
                return !(validation.password && validation.code);
            default:
                return true
        }
    }

    return (
        <>

            {showError &&
            <ErrorModal showError={showError} error={error}
                        toggleErrorModal={toggleErrorModal}/>
            }

            <Col lg="6" md="8" className="mt--100">
                <LoadingOverlay
                    active={isLoading}
                    spinner={<RotateCircleLoading color="white"/>}
                    text=''
                >
                    <Card className="bg-secondary shadow border-0">
                        <Row className="align-content-center"
                             style={{marginTop: "-50px", marginLeft: "6px"}}><LanguagePanel
                            onResult={onLanguageChanged}/></Row>
                        <CardBody className="px-lg-5 py-lg-5">

                            <Form role="form">
                                <Row className="mb-4">

                                </Row>
                                <FormGroup>
                                    <InputGroup className="input-group-alternative mb-3">
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText>

                                                {validation.email === true ?
                                                    (<i className="fas fa-envelope"/>) :
                                                    (<i className="fas fa-envelope text-danger"/>)
                                                }
                                            </InputGroupText>
                                        </InputGroupAddon>
                                        <Input placeholder={commonStrings.email}
                                               type="email"
                                               autoComplete="new-email"
                                               disabled={stage === constants.passwordResetStage.reset}
                                               id="input-email" onChange={handleChange}/>
                                    </InputGroup>
                                </FormGroup>
                                {stage === constants.passwordResetStage.reset &&
                                <FormGroup>
                                    <InputGroup className="input-group-alternative mb-3">
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText>
                                                {validation.code === true ?
                                                    (<i className="fas fa-key"/>) :
                                                    (<i className="fas fa-key text-danger"/>)
                                                }
                                            </InputGroupText>
                                        </InputGroupAddon>
                                        <Input
                                            placeholder={commonStrings.reset_token} type="text" id="input-reset-code" spellcheck="false"
                                            onChange={handleChange}/>
                                    </InputGroup>
                                </FormGroup>
                                }
                                {stage === constants.passwordResetStage.reset &&
                                <FormGroup>
                                    <InputGroup className="input-group-alternative">
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText>
                                                {validation.password === true ?
                                                    (<i className="fas fa-lock"/>) :
                                                    (<i className="fas fa-lock text-danger"/>)
                                                }
                                            </InputGroupText>
                                        </InputGroupAddon>
                                        <Input placeholder={commonStrings.password} type="password"
                                               autoComplete="new-password" id="input-password" spellcheck="false"
                                               onChange={handleChange}/>
                                    </InputGroup>
                                </FormGroup>
                                }
                                <div className="text-muted font-italic">
                                    {/*<small>*/}
                                    {/*  password strength:{" "}*/}
                                    {/*  <span className="text-success font-weight-700">{passwordStrength}</span>*/}
                                    {/*</small>*/}
                                </div>
                                <div className="text-center">
                                    <Button className="mt-4" color="yellowopen" type="button"
                                            onClick={e => handleSubmit(e)}
                                            disabled={stageValidation()}
                                    >
                                        {stage === constants.passwordResetStage.forgot ? commonStrings.send_reset_token : commonStrings.reset_password}
                                    </Button>
                                </div>

                                <Row>
                                    <small
                                        className="text-warning mt-4 ml-4 mr-4 text-center">{stage === constants.passwordResetStage.forgot ? commonStrings.send_reset_token_expl : commonStrings.reset_password_expl}</small>
                                </Row>
                            </Form>
                        </CardBody>
                    </Card>
                    <Row className="mt-3">
                        <Col xs="6">
                            <a
                                className="text-light"
                                href="#password_reset"
                                onClick={e => goToRegister(e)}
                            >
                                <small>{commonStrings.create_account}</small>
                            </a>
                        </Col>
                        <Col className="text-right" xs="6">
                            <a
                                className="text-light"
                                href="#login"
                                onClick={e => goToLogin(e)}
                            >
                                <small>{commonStrings.login}</small>
                            </a>
                        </Col>
                    </Row>
                </LoadingOverlay>

            </Col>
        </>
    );

    function localize() {
        commonStrings.setLanguage(locale);
        // alertStrings.setLanguage(loc);
        // resourceStrings.setLanguage(loc);
    }
};

export default PasswordReset;
